var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "链接类型", prop: "url_type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: { placeholder: "请选择链接类型" },
                      model: {
                        value: _vm.localForm.url_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.localForm, "url_type", $$v)
                        },
                        expression: "localForm.url_type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "站内链接", value: "inner" },
                      }),
                      _c("el-option", {
                        attrs: { label: "站外链接", value: "outer" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "链接地址", prop: "jump_url" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "350px" },
                    attrs: {
                      placeholder: "请输入链接地址",
                      maxlength: "255",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.localForm.jump_url,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localForm,
                          "jump_url",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "localForm.jump_url",
                    },
                  }),
                  _vm.localForm.url_type === "inner"
                    ? _c(
                        "div",
                        {
                          staticClass: "status-tip",
                          staticStyle: { "margin-left": "10px" },
                        },
                        [_vm._v("站内链接需以 / 开头")]
                      )
                    : _vm.localForm.url_type === "outer"
                    ? _c(
                        "div",
                        {
                          staticClass: "status-tip",
                          staticStyle: { "margin-left": "10px" },
                        },
                        [_vm._v(" 站外链接需以 http:// 或 https:// 开头 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }